<template>
  <div class="tab-box">
    <span
      class="tab-item"
      v-for="(item, index) in tabTypeItem"
      :key="index + 'tab'"
      @click="switchType(item, index)"
      :class="{
        selected: tabIndex === item.value,
      }"
    >
      {{ item.title }}
    </span>
    <span class="tab-underline" :style="tabLineStyle"></span>
  </div>
</template>
<script>
import { number } from "echarts";
export default {
  props: {
    tabTypeItem: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      tabLineStyle: {},
      tabIndex: 0,
    };
  },
  watch: {
    tabIndex() {
      this.setTabLineStyle();
    },
  },
  methods: {
    switchType(item, tabIndex) {
      this.tabIndex = item.value;
      this.$emit("handleChangeTab", item);
    },
    setTabLineStyle() {
      const $tabList = document.querySelectorAll(".tab-box .tab-item");
      const { offsetLeft, offsetWidth } = $tabList[this.tabIndex];
      if (!offsetWidth) return;
      this.tabLineStyle = {
        left: `${offsetLeft + (offsetWidth - 23) / 2}px`,
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.setTabLineStyle();
      }, 500);
    });
  },
};
</script>
<style lang="scss" scoped>
.tab-box {
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  position: relative;
  border: 0;
  border-bottom: 1px solid #EBEBEB;
  background: #fff;
  font-family: HarmonyOS-Regular;
  .tab-item {
    font-size: 14px;
    margin-right: 40px;
    display: inline-block;
    cursor: pointer;
    border: 0;
    height: auto;
    font-size: 16px;
    color: #93979d;
    &.selected {
      color: var(--theme-tab-active-text);
      background: transparent;
      border-color: transparent;
    }
  }
  .all-order-btn {
    float: right;
    cursor: pointer;
    font-size: 12px;
    .common-checkout {
      position: relative;
      top: 2px;
    }
  }
  .tab-underline {
    position: absolute;
    width: 23px;
    height: 2px;
    bottom: 0px;
    left: 24px;
    transition: all 0.3s;
    background: var(--theme-primary);
  }
}
</style>
